import React, { MutableRefObject, useEffect, useRef } from 'react';
import { Route, Switch } from 'react-router-dom';
import Main from 'Main';
import { ROUTES_DATA } from 'utils/Constants';
import { validateCurrentUser } from 'store/slices/auth';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { Map } from 'mapbox-gl';
import { globalStyles } from './theme/GlobalStyle';
import theme from 'theme';
import '@fontsource/fredoka-one';
import '@fontsource/viga';

import { GlobalStyles, ThemeProvider } from '@mui/material';
import { useNewRelic } from './hooks/useNewRelic';

function App() {
    useNewRelic();
    const dispatch = useAppDispatch();
    const mapRef: MutableRefObject<Map | null> = useRef<Map | null>(null);

    useEffect(() => {
        dispatch(validateCurrentUser());
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyles styles={globalStyles}/>
            <Main mapRef={mapRef}>
                <Switch>
                    {ROUTES_DATA.map((r, idx) => (
                        <Route key={`route-${idx}`} path={r.path} exact component={r.component}/>
                    ))}
                </Switch>
            </Main>
        </ThemeProvider>
    );
}

export default App;
